import React, { useState, useEffect ,useContext} from "react";
import { Box, Paper, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Switch,useTheme,useMediaQuery, Tabs, Tab, Snackbar, Alert } from "@mui/material";
import api from "../api";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SelectInput from "../customcomponents/CustomSelectInput";
import TuneIcon from "@mui/icons-material/Tune";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuIcon from "@mui/icons-material/Menu";
import { SettingsContext } from '../App';

const fadeIn = {
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  animation: "fadeIn 0.8s cubic-bezier(0.4,0,0.2,1)",
};

export default function PagePermissionPage() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [roles, setRoles] = useState([]);
  const [pagesData, setPagesData] = useState([]);
  const [sidebarData, setSidebarData] = useState([]);
  const [loadingToggle, setLoadingToggle] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const {settings,userRole}=useContext(SettingsContext);
  const [selectedRole,setSelectedRole]=useState(userRole || null);
  

  

  useEffect(() => {
    fetchRoles();
    fetchPagePermissions();
    fetchSidebarPermissions();
  }, []);

  const fetchRoles = async () => {
    try {
      const res = await api.get("/roles");
      setRoles(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      setRoles([]);
    }
  };

  const fetchPagePermissions = async () => {
    try {
      const res = await api.get("/page-settings");
      setPagesData(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      setPagesData([]);
    }
  };

  const fetchSidebarPermissions = async () => {
    try {
      const res = await api.get("/page-settings/sidebar");
      setSidebarData(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      setSidebarData([]);
    }
  };
  

  // console.log(roles);
  
  const roleOptions = roles.map((r) => ({ value: r._id, label: r.TA_Role_Name }));

  const handleRoleChange = async (roleId) => {
    setSelectedRole(roleId || null);
    // Ensure we have latest page-settings from server in case mappings changed
    try {
      const res = await api.get('/page-settings');
      setPagesData(Array.isArray(res.data?.data) ? res.data.data : []);
      const sidebarRes = await api.get('/page-settings/sidebar');
      setSidebarData(Array.isArray(sidebarRes.data?.data) ? sidebarRes.data.data : []);
    } catch (err) {
      // keep existing data on error
    }
  };

  const togglePageRole = async (pageId, assign) => {
    if (!selectedRole && assign) return; 
    setLoadingToggle(true);
    try {
      const payload = {
        TAP_User_Role_Ref: selectedRole || null,
      };
      
      const response = await api.put(`/page-settings/${pageId}`, payload);
      
      console.log('Toggle response:', response.data);

      // Update local state for both pages and sidebar
      setPagesData(prev =>
        prev.map(p => {
          if (p.id !== pageId) return p;

          const alreadyAssigned = p.roles?.some(r => r.id === selectedRole);

          let updatedRoles;
          if (alreadyAssigned) {
            // REMOVE ROLE
            updatedRoles = p.roles.filter(r => r.id !== selectedRole);
          } else {
            // ADD ROLE
            updatedRoles = [...p.roles, { id: selectedRole }];
          }

          return { ...p, roles: updatedRoles };
        })
      );

      // Also update sidebar data if this is a sidebar item
      setSidebarData(prev =>
        prev.map(s => {
          if (s.id !== pageId) return s;

          const alreadyAssigned = s.roles?.some(r => r.id === selectedRole);

          let updatedRoles;
          if (alreadyAssigned) {
            // REMOVE ROLE
            updatedRoles = s.roles.filter(r => r.id !== selectedRole);
          } else {
            // ADD ROLE
            updatedRoles = [...s.roles, { id: selectedRole }];
          }

          return { ...s, roles: updatedRoles };
        })
      );

      // Show success message
      setSnackbar({
        open: true,
        message: response.data.message || 'Permission updated successfully',
        severity: 'success'
      });

    } catch (err) {
      console.error('Failed to toggle page role', err);
      setSnackbar({
        open: true,
        message: err.response?.data?.message || 'Failed to update permission',
        severity: 'error'
      });
    } finally {
      setLoadingToggle(false);
    }
  };

  // Group by category
  const groupedPages = pagesData.reduce((acc, curr) => {
    if (!acc[curr.category]) acc[curr.category] = [];
    acc[curr.category].push(curr);
    return acc;
  }, {});

  const assignedPages = pagesData.filter(p => selectedRole && p.roles?.some(r => r.id === selectedRole) && p.active);
  const assignedSidebarItems = sidebarData.filter(p => selectedRole && p.roles?.some(r => r.id === selectedRole) && p.active);

  return (
    <Box sx={{ px: isSmallScreen ? 1 : 0}}>
      <Paper sx={{
            p: isSmallScreen ? 2 : 3, mb: 3, borderRadius: 3, display: "flex", alignItems: "center", justifyContent: "space-between",
            background: "background.paper", color: "black", boxShadow: 4, mt: isSmallScreen ? 1 : 0, flexWrap: "wrap", gap: 2, ...fadeIn,
        }}>
         <Typography variant={isSmallScreen ? "h5" : "h4"} fontWeight={700} sx={{ color: "background.text" }} >
            Access Control
        </Typography>
        <Box sx={{ minWidth: isSmallScreen?'100%': 200 }}>
        <SelectInput
          label="Select Role"
          options={roleOptions}
          value={selectedRole || ''}
          onChange={(e) => handleRoleChange(e.target.value)}
          sx={{
            width: "100%",
            backgroundColor: "background.paper",
            color:'background.text'
          }}
        />
        </Box>
      </Paper>

      {/* TABS */}
      <Paper sx={{ mb: 3, borderRadius: 3 }}>
        <Tabs 
          value={activeTab} 
          onChange={(e, val) => setActiveTab(val)}
          sx={{ borderBottom: "1px solid rgba(0,0,0,0.1)" }}
        >
          <Tab label="Page Permissions" sx={{ fontWeight: 600 }} />
          <Tab label="Sidebar Permissions" sx={{ fontWeight: 600 }} />
        </Tabs>
      </Paper>

      {/* PAGE PERMISSIONS TAB */}
      {activeTab === 0 && (
      <Grid container spacing={3}>
        {/* LEFT PANEL */}
        <Grid item xs={12} md={7}>
          <Paper sx={{ p: 0, borderRadius: 3, overflow: "hidden" }}>
            {isSmallScreen ? (
              <Box sx={{ px: 3, py: 2 }}>
                <Typography variant="h6" fontWeight={700} sx={{ color: "background.text" }}>Pages & Permissions</Typography>
              </Box>)
            :(
            <Box sx={{ backgroundColor: "primary.main", px: 3, py: 2 }}>
              <Typography variant="h6" fontWeight={700} sx={{ color: "white" }}>Pages & Permissions</Typography>
            </Box>
            )}

            <Box sx={{ p: 2, maxHeight: 600, overflowY: "auto" }}>
              {Object.entries(groupedPages).map(([category, items], idx) => (
                <Accordion key={idx} disableGutters elevation={0} sx={{ mb: 2, border: "1px solid rgba(0,0,0,0.1)", borderRadius: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}> 
                    <Typography sx={{ fontWeight: 700,textTransform:'capitalize', color:'background.text' }}>{category}</Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <List>
                      {items.map((item, i) => (
                        <ListItem
                          key={i}
                          sx={{ py: 1.2, borderBottom: "1px dashed rgba(0,0,0,0.06)" }}
                          // onClick={()=>{console.log(item)}}
                          secondaryAction={
                           <Switch
                            edge="end"
                            onClick={(e) => e.stopPropagation()}
                            checked={
                              !!selectedRole &&
                              item.roles?.some(r => r.id === selectedRole) &&
                              item.active
                            }
                            onChange={async (e) => {
                              if (!selectedRole) return;
                              const checked = e.target.checked;
                              const confirmed = window.confirm(
                                checked 
                                  ? "Are you sure you want to enable this permission?"
                                  : "Are you sure you want to disable this permission?"
                              );
                              if (!confirmed) {
                                e.target.checked = !checked;
                                return;
                              }
                              await togglePageRole(item.id, checked);
                            }}
                            color="primary"
                            disabled={!selectedRole || loadingToggle}
                          />

                          }
                        >
                          <TuneIcon sx={{ color: "primary.main", fontSize: "1.2rem", mr: 1 }} />
                          <ListItemText sx={{textTransform:'capitalize', color:'background.gradienttext'}} primary={item.qname} />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Paper>
        </Grid>

        {/* RIGHT PANEL */}
        <Grid item xs={12} md={5}>
          <Paper sx={{ p: 0, borderRadius: 3 }}>
            <Box sx={{ backgroundColor: "primary.main", px: 3, py: 2,borderTopLeftRadius:10,borderTopRightRadius:10 }}>
              <Typography variant="h6" fontWeight={700} sx={{ color: "white" }}>Current Permissions</Typography>
            </Box>

            <Box sx={{ p: 0, maxHeight: 600, overflowY: "auto" }}>
              {!selectedRole ? (
                <Typography sx={{ color: "red",fontWeight:600, textAlign: "center", py: 4 }}>
                  Select a role to view current permissions.
                </Typography>
              ) : assignedPages.length === 0 ? (
                <Typography sx={{ color: "text.secondary", textAlign: "center", py: 4 }}>
                  No permissions assigned.
                </Typography>
              ) : (
                <List sx={{ px:1 }}>
                  {[...assignedPages]
                    .sort((a, b) => a.category.localeCompare(b.category))
                    .map((p) => (
                      <ListItem
                        key={p.id}
                        sx={{
                          py: 1,
                          borderBottom: "1px solid rgba(0,0,0,0.06)",
                          ":last-child": { borderBottom: "none" },
                        }}
                      >
                        <ListItemText sx={{ textTransform: 'capitalize',color:'background.gradienttext' }}>
                          <b sx={{color:'background.gradienttext'}}>{p.category}</b> <ChevronRightIcon fontSize="20" /> {p.qname}
                        </ListItemText>
                      </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
      )}

      {/* SIDEBAR PERMISSIONS TAB */}
      {activeTab === 1 && (
      <Grid container spacing={3}>
        {/* LEFT PANEL */}
        <Grid item xs={12} md={7}>
          <Paper sx={{ p: 0, borderRadius: 3, overflow: "hidden" }}>
            {isSmallScreen ? (
              <Box sx={{ px: 3, py: 2 }}>
                <Typography variant="h6" fontWeight={700} sx={{ color: "background.text" }}>Sidebar Items & Permissions</Typography>
              </Box>)
            :(
            <Box sx={{ backgroundColor: "primary.main", px: 3, py: 2 }}>
              <Typography variant="h6" fontWeight={700} sx={{ color: "white" }}>Sidebar Items & Permissions</Typography>
            </Box>
            )}

            <Box sx={{ p: 2, maxHeight: 600, overflowY: "auto" }}>
              <List>
                {sidebarData.map((item, i) => (
                  <ListItem
                    key={i}
                    sx={{ py: 1.2, borderBottom: "1px dashed rgba(0,0,0,0.06)", borderRadius: 1, mb: 0.5 }}
                    secondaryAction={
                      <Switch
                        edge="end"
                        onClick={(e) => e.stopPropagation()}
                        checked={
                          !!selectedRole &&
                          item.roles?.some(r => r.id === selectedRole) &&
                          item.active
                        }
                        onChange={async (e) => {
                          if (!selectedRole) return;
                          const checked = e.target.checked;
                          const confirmed = window.confirm(
                            checked 
                              ? "Are you sure you want to enable this permission?"
                              : "Are you sure you want to disable this permission?"
                          );
                          if (!confirmed) {
                            e.target.checked = !checked;
                            return;
                          }
                          await togglePageRole(item.id, checked);
                        }}
                        color="primary"
                        disabled={!selectedRole || loadingToggle}
                      />
                    }
                  >
                    <MenuIcon sx={{ color: "primary.main", fontSize: "1.2rem", mr: 1 }} />
                    <ListItemText sx={{textTransform:'capitalize', color:'background.gradienttext'}} primary={item.qname}  />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Paper>
        </Grid>

        {/* RIGHT PANEL */}
        <Grid item xs={12} md={5}>
          <Paper sx={{ p: 0, borderRadius: 3 }}>
            <Box sx={{ backgroundColor: "primary.main", px: 3, py: 2,borderTopLeftRadius:10,borderTopRightRadius:10 }}>
              <Typography variant="h6" fontWeight={700} sx={{ color: "white" }}>Current Sidebar Permissions</Typography>
            </Box>

            <Box sx={{ p: 0, maxHeight: 600, overflowY: "auto" }}>
              {!selectedRole ? (
                <Typography sx={{ color: "red",fontWeight:600, textAlign: "center", py: 4 }}>
                  Select a role to view current permissions.
                </Typography>
              ) : assignedSidebarItems.length === 0 ? (
                <Typography sx={{ color: "text.secondary", textAlign: "center", py: 4 }}>
                  No sidebar items assigned.
                </Typography>
              ) : (
                <List sx={{ px:1 }}>
                  {assignedSidebarItems.map((p) => (
                    <ListItem
                      key={p.id}
                      sx={{
                        py: 1,
                        borderBottom: "1px solid rgba(0,0,0,0.06)",
                        ":last-child": { borderBottom: "none" },
                      }}
                    >
                      <ListItemText sx={{ textTransform: 'capitalize',color:'background.gradienttext' }}>
                        <MenuIcon fontSize="small" sx={{ mr: 0.5, verticalAlign: 'middle' }} />
                        {p.qname}
                      </ListItemText>
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
      )}

      {/* SNACKBAR FOR NOTIFICATIONS */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}